import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const PieGraph = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  useEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.PieChart
    );
    x.background.fill = "#2F3640";
    x.background.opacity = 0.5;
    if (props.data) {
      x.data = props.data;
      /* Create axes */
      var pieSeries = x.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "Val";
      pieSeries.dataFields.category = "Series";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeOpacity = 0;
      pieSeries.labels.template.maxWidth = 90;
      pieSeries.labels.template.fontSize = 11;
      pieSeries.labels.template.wrap = true;
      pieSeries.labels.template.fill = am4core.color("#7f7f7f");

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;
      pieSeries.alignLabels = false;
      x.radius = am4core.percent(65);

      x.hiddenState.properties.radius = am4core.percent(0);

      chart.current = x;
    }

    return () => {
      x.dispose();
    };
  });

  return (
    <div>
      {props.data ? (
        <div
          id={props.divId ? props.divId : "DivID"}
          style={{ width: "100%", height: "330px" }}
        ></div>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default PieGraph;
